import { QueryClient } from '@tanstack/react-query';

/** Shared server-state cache used across routed pages and shared selectors. */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      // Revisit a page within a few minutes and paint the last result immediately.
      staleTime: 3 * 60 * 1000,
      gcTime: 15 * 60 * 1000,
      refetchOnWindowFocus: false,
      refetchOnReconnect: true,
      refetchIntervalInBackground: false,
    },
  },
});

/** Drop all in-memory query data so the next authenticated session cannot reuse it. */
export function clearAuthenticatedQueryCache() {
  queryClient.clear();
}
